"use client";
import CustomModal from "@/components/modal/CustomModal";
import React, { useCallback, useState } from "react";
import TrailingRetrunsChart from "../charts/TrailingRetrunsChart";
import Icon from "@/components/icons/Icons";
import { SchemeReturn } from "@/type/schemeType";
import Image from "next/image";
import { useLoginModal } from "@/utils/useLoginModal";
import { ROOT_URL } from "@/utils/gloableVariables";

type PropData = {
  data: SchemeReturn;
  className?: string;
};

export default function TrailingChartModal({ data, className }: PropData) { 
  const [isOpen, setIsOpen] = useState(false);

  const handleCloseButton = useCallback(() => {
    setIsOpen(false);
  }, []);

  const { isLoggedIn, open, setModalKey } = useLoginModal();

  return (
    <>
      <button
        onClick={
          isLoggedIn
            ? () => setIsOpen(true)
            : () => {
                open();
                setModalKey("trailing-return-chart");
              }
        }
        className={`${className} group items-center w-full sm:w-auto justify-center gap-2 border border-primaryBlue rounded-xl sm:rounded-lg text-2xs font-semibold text-primaryBlue leading-4 py-2 px-4 sm:ml-auto mt-5 sm:mt-0 transition-all duration-350 sm:hover:bg-primaryBlue sm:hover:text-white`}
      >
        View Graph Analysis
        <svg width="16" height="17" viewBox="0 0 16 17" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path d="M9.61984 4.1176L13.6665 8.16427L9.61984 12.2109" stroke="current" strokeWidth="1.5" strokeMiterlimit="10" strokeLinecap="round" strokeLinejoin="round" className="stroke-primaryBlue transition-all duration-350 sm:group-hover:stroke-white" />
          <path d="M2.33029 8.16406H13.5503" stroke="current" strokeWidth="1.5" strokeMiterlimit="10" strokeLinecap="round" strokeLinejoin="round" className="stroke-primaryBlue transition-all duration-350 sm:group-hover:stroke-white" />
        </svg>
      </button>

      <CustomModal isOpen={isOpen} onClose={handleCloseButton} maxSize="max-w-206.5" className="bg-white rounded-4xl px-0 pb-3 xs:pb-4 xs:px-4 sm:p-6" showCloseButton={false} useDragToClose={true}>
        <div className="flex justify-between items-center mb-6 sm:mb-8 px-4 xs:px-0">
          <p className="text-base sm:text-1.5xl sm:leading-7 text-primaryBlack font-bold">Trailing Returns - Graph Analysis</p>

          <button onClick={() => setIsOpen(false)} className="w-6 h-6">
            <Icon.popupCloseIcon className="w-5 h-5 rotate-45 transition duration-350 text-[#6E6E73] hover:text-primaryBlue" />
          </button>
        </div>

        <div className="flex items-center gap-2 mb-6 sm:mb-8 px-4 xs:px-0">
          <Image src={`${ROOT_URL}img/AMCsLogo/${data.amc_code}.png`} alt={data.scheme_name} width={40} height={40} className="w-4.5 h-4.w-4.5 sm:w-10 sm:h-10 overflow-hidden shrink-0 border border-[#E9E9EB] rounded-full" />
          <p className="text-sm sm:text-xl font-medium text-primaryBlack line-clamp-2">{data.scheme_name}</p>
        </div>

        <div>
          <TrailingRetrunsChart data={data} />
        </div>
      </CustomModal>
    </>
  );
}
